import store from "./components/Stores/SurveyStore";
import ibsStore from "./components/Stores/IbsSurveyStore"
import userStore from "./components/Stores/UserStore"
import numeral from "numeral";
import {addErrorCommentsCtrl} from "../src/control"
import {AssetTableViewMode, MonthLength, PlaceholderFormat, SurveyTypeURL} from "./Enums/constants";
import crypto from 'crypto'
import React from 'react';

// Used when displaying a page name 
// If the switch statment hits more than 3 cases, turn into a map
export function pageNameDisplayOverride(pageName) {
    if (typeof pageName === "undefined" || pageName === null) {
        return "";
    }
    switch (pageName) {
        case "Td&Balanced":
            return "TD & Balanced";
        case "Ltd partnerships":
            return "Ltd. partnerships";
        default:
            return pageName;
    }

}

export function normalizeSelectInput(value, options) {
    if (value === null) value = ""

    //called from onChange, saves into response data
    value = value.toString().toLowerCase() //not sure if i should save to frontend version lowercased, double check!!

    var newValue = value;

    if (store.surveyTypeUrl === SurveyTypeURL.DC || store.surveyTypeUrl == SurveyTypeURL.DB) {

        newValue = Object.keys(options).find(key => options[key].toLowerCase() === value);

        //special select
    } else if (store.surveyTypeUrl == SurveyTypeURL.PABS || store.surveyTypeUrl == SurveyTypeURL.PABS_UK) {

        // Ensure options is always an array
        const optionsArray = Object.values(options);

        newValue = optionsArray.filter(label => label.toLowerCase() === value.toLowerCase());

        if (newValue.length > 0) newValue = newValue[0].toLowerCase();
    }

    return newValue;
}


// TODO: Look at this function
export function getNormalizedSelectInput(value, options) {
    //called from getValue()
    if (store.surveyTypeUrl === SurveyTypeURL.DC || store.surveyTypeUrl == SurveyTypeURL.DB) {
        if (typeof (value) == "string" && (value == null || value == "")) return (options[null])

        if (typeof (value) == "boolean") {
            var i = value ? 1 : 0;
            return (options[i])
        }
       
        return (options[value]);
    }

    // PABS Case
    if (value != null && value.toLowerCase() === "n/a") { return "N/A"; };
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export function assetsContainsAC(assetClass) {
    let mandateLevel = ibsStore.checkMandateLevel;
    let mandates = ibsStore.mandateData ?? [];
    let assets = ibsStore.allTableResponses["combinedAssets"] ?? [];

    if (mandateLevel === AssetTableViewMode.ASSET_ONLY_VIEW) {
        mandates = [];
    }
    if (mandateLevel === AssetTableViewMode.MANDATE_ONLY_VIEW) {
        assets = [];
    }

    mandates = mandates.filter(mandate => mandate.assetClassID === assetClass);
    assets = assets.filter(asset => asset.AssetClassID === assetClass);

    if (mandates.length > 0 || assets.length > 0) {
        return true;
    }

    return false;

}

export function errorExplanationOptions(name, inputRenderingInfo, value) {
    if (inputRenderingInfo.errorExplanation) {
        return (<React.Fragment>Your comment : <a onClick={() => showErrorCommentModal(name, value, inputRenderingInfo, null, inputRenderingInfo.actualErrorId)} className="error-explanation-text"> {inputRenderingInfo.errorExplanation} </a></React.Fragment>)

    } else if (inputRenderingInfo.errorId == 1 && !inputRenderingInfo.errorExplanation) {
        return (<a onClick={() => dismissWarning(name, null, inputRenderingInfo.actualErrorId, store.local.dismissText)} className="click-to-dismiss">
            {store.local.clickDismiss}</a>)
    } else if (inputRenderingInfo.errorId == 2 && !inputRenderingInfo.errorExplanation) {
        const isPabsSurvey = store.surveyTypeUrl === SurveyTypeURL.PABS || store.surveyTypeUrl === SurveyTypeURL.PABS_UK || store.surveyTypeUrl === SurveyTypeURL.PABS_LG;
        return (
            <React.Fragment><a onClick={() => showErrorCommentModal(name, value, inputRenderingInfo, null, inputRenderingInfo.actualErrorId)} className="click-to-dismiss">
                {store.local.addExplanation}</a>&nbsp; or &nbsp;
                {isPabsSurvey &&
                    <a onClick={() => dismissWarning(name, null, inputRenderingInfo.actualErrorId, store.local.dismissText)} className="click-to-dismiss">
                        {store.local.clickDismiss.toLowerCase()}</a>}
                {(store.surveyTypeUrl == SurveyTypeURL.DB || store.surveyTypeUrl == SurveyTypeURL.DC) &&
                    <a onClick={() => dismissWarning(name, null, inputRenderingInfo.actualErrorId, store.local.dismissText)} className="click-to-dismiss">
                        {store.local.clickDismiss.toLowerCase()}</a>}


            </React.Fragment>
        );

    }
}

export function showErrorCommentModal(questionName, inputValue, inputRenderingInfo, rowId, errorId) {
    //only show modal if allowed (ie analyst and read only, or not read only for anyone)
    if (store.userCanEditReadOnlySurvey) {
        setCurrentErrorCommentInfo(questionName, inputValue, rowId, errorId)
        if (inputRenderingInfo.errorId == 2) {
            store.showErrorCommentModal = true;
        }
        else if (typeof inputRenderingInfo?.errorExplanation !== "undefined" && inputRenderingInfo?.errorExplanation !== null) {
            store.errorCommentContent.TempErrorExplanation = "";
            addErrorCommentsCtrl();
        }
    }
}

export function dismissWarning(questionName, rowId, errorId, comment) {
    if (store.userCanEditReadOnlySurvey) { //change to grab from elsewhere (ie user has access bool)
        //console.log('dismissing error', questionName)

        if (typeof rowId === 'undefined' || rowId == null) {
            rowId = 1;
        }

        if (typeof errorId === 'undefined') {
            errorId = null;
        }

        store.errorCommentContent.QuestionName = questionName;
        store.errorCommentContent.TempErrorExplanation = comment;
        store.errorCommentContent.RowID = rowId;
        store.errorCommentContent.ErrorId = errorId;
        addErrorCommentsCtrl()
    }
}

export function useDefaultWarning(questionName, rowId, errorId) {
    if (store.userCanEditReadOnlySurvey) { //change to grab from elsewhere (ie user has access bool)
        //console.log('dismissing error', questionName)

        if (typeof rowId === 'undefined' || rowId == null) {
            rowId = 1;
        }

        if (typeof errorId === 'undefined') {
            errorId = null;
        }

        store.errorCommentContent.QuestionName = questionName;
        store.errorCommentContent.TempErrorExplanation = store.local.defaultText;
        store.errorCommentContent.RowID = rowId;
        store.errorCommentContent.ErrorId = errorId;
        addErrorCommentsCtrl()
    }
}

export function redirectToPage(page) {
    if (page != store.currentLandedPage) {
        if (store.surveyTypeUrl === SurveyTypeURL.PABS) {
            window.location.pathname = "./pabs/" + page;
        }
        else if (store.surveyTypeUrl === SurveyTypeURL.DB) {
            window.location.pathname = "./db/" + page;
        }
        else if (store.surveyTypeUrl === SurveyTypeURL.DC) {
            window.location.pathname = "./dc/" + page;
        }

    }
}

//Number Formatting Error Handling
export function getUiNumInputErrorState(name, participantType = null) {
    if (store.currentPageResponse) {
        const result = store.currentPageResponse.filter(obj => {
            return obj.QuestionName === name
        });

        if (result[0] != null) {
            return (result[0].ErrorState)
        }
    } else {
        const result = ibsStore.allResponseErrorStates.filter(obj => {
            return obj.QuestionName.toLowerCase() === name.toLowerCase() && obj.ParticipantType === participantType
        });
        
        if (result[0] != null) {
            return (result[0].ErrorState)
        }
    }
}

export function setUiNumInputErrorState(name, valid, participantType=null) {
    const state = valid === true ? "validInput" : "invalidInput";
    if (store.currentPageResponse) {
        let result = store.currentPageResponse.filter(obj => {
            return obj.QuestionName.toLowerCase() === name.toLowerCase()
        })

        if (result[0] != null) {
            result[0].ErrorState = state;
        } else {
            // No saved response row exists yet (e.g. an unanswered field). Without this,
            // an invalid entry on a never-answered question would silently drop its error
            // state and skip the "Invalid Format" feedback. Mirror the IBS branch below.
            store.currentPageResponse.push({ "QuestionName": name, "ErrorState": state });
        }
    } else {
        let result = ibsStore.allResponseErrorStates.filter(obj => {
            return obj.QuestionName.toLowerCase() === name.toLowerCase() && obj.ParticipantType === participantType
        })
        
        if (result.length === 0) 
            ibsStore.allResponseErrorStates.push({ 'QuestionName': name, 'ErrorState': state, 'ParticipantType' : participantType })
        else 
            result[0].ErrorState = state
    }
}

export function getCommentValue() {
    //rowData one needs to be fixed so we can change values from the original json object not a passed down object
    let responseValue = ""
    if (store.currentPageResponse) {
        let result = store.currentPageResponse.filter(obj => {
            return obj.QuestionName === store.commentAnalystContent.QuestionName;
        })

        //responseValue = result[0]['inputValue']
        if (result[0] && store.commentAnalystContent.TempComment) {
            responseValue = store.commentAnalystContent.TempComment
        } else {
            responseValue = "";
        }

    }
    return responseValue;
}



//Commenting 
export function setTempAnalystCommentValue(value) {
    store.commentAnalystContent.TempComment = value;
}

export function setActualCommentValue() {
    if (store.currentPageResponse) {
        let result = store.currentPageResponse.filter(obj => {
            return obj.QuestionName.toLowerCase() === store.commentAnalystContent.QuestionName.toLowerCase()
        })
        if (result[0] != null) {
            result[0].Comment = store.commentAnalystContent.TempComment;
        }

    }

}

export function setActualErrorCommentValue() {
    let rowId = (typeof store.errorCommentContent.RowID === 'undefined') ?
        1 :
        store.errorCommentContent.RowID;

    var page = store.currentLandedPage;

    //mandate table
    if (rowId[0] == 'A') {
        //page = "mandate_data"
        rowId = rowId.substring(1);
    }

    if (store.allValidationErrorsList[page]) {
        if (store.surveyTypeUrl === SurveyTypeURL.DB || store.surveyTypeUrl === SurveyTypeURL.DC) {
            var result = store.allValidationErrorsList[page].filter(obj => {
                return (obj.QuestionName.toLowerCase() === store.errorCommentContent.QuestionName.toLowerCase()
                    && obj.RowID == rowId
                );
            })
        } else {
            var result = store.allValidationErrorsList[page].filter(obj => {
                return (obj.QuestionName.toLowerCase() === store.errorCommentContent.QuestionName.toLowerCase()
                );
            })
        }


        if (result[0] != null) {
            result[0].ErrorExplanation = store.errorCommentContent.TempErrorExplanation;
        }
    }

}


export function setCurrentCommentInfo(name) {
    if (store.currentPageResponse) {
        var result = store.currentPageResponse.filter(obj => {
            return obj.QuestionName.toLowerCase() === name.toLowerCase()
        })
        if (result[0] && result[0].Comment) {
            //comment exists for this question
            store.commentAnalystContent.ProvidedValue = result[0].ProvidedValue
            if (result[0].DateModified) store.commentAnalystContent.DateModified = result[0].DateModified.substring(0, 10)
            store.commentAnalystContent.EditedBy = result[0].Name
            store.commentAnalystContent.CurrentValue = result[0].InputValue
            store.commentAnalystContent.QuestionName = result[0].QuestionName;
            store.commentAnalystContent.TempComment = result[0].Comment;
            store.commentAnalystContent.Comment = result[0].Comment;


        } else {
            //set all to "" have to clear everything
            store.commentAnalystContent.ProvidedValue = ""
            store.commentAnalystContent.DateModified = ""
            store.commentAnalystContent.EditedBy = ""
            if (result[0]) {
                store.commentAnalystContent.CurrentValue = result[0].InputValue
                store.commentAnalystContent.QuestionName = result[0].QuestionName
            } else
            {
                store.commentAnalystContent.CurrentValue = ""
                store.commentAnalystContent.QuestionName=""
            }
            store.commentAnalystContent.Comment = ""
            store.commentAnalystContent.TempComment = "";

        }
    }

}

export function setCurrentErrorCommentInfo(name, value, rowId, errorId) {
    //console.log(store.allValidationErrorsList);
    if (typeof rowId === 'undefined' || rowId == null)
        rowId = 1;
    if (typeof errorId === 'undefined')
        errorId = null;
    var page = store.currentLandedPage;
    var strippedRowId = rowId;
    if (rowId[0] == 'A') {
        strippedRowId = rowId.substring(1)
        //page = "mandate_data"
    }

    if (store.allValidationErrorsList[page]) {
        if (store.surveyTypeUrl === SurveyTypeURL.DB || store.surveyTypeUrl === SurveyTypeURL.DC) {
            var result = store.allValidationErrorsList[page].filter(obj => {
                //console.log('set comment', obj.QuestionName.toLowerCase(), name.toLowerCase() )
                return (obj.QuestionName.toLowerCase() === name.toLowerCase() && obj.RowID == strippedRowId)
            })
        } else {
            var result = store.allValidationErrorsList[page].filter(obj => {
                //console.log('set comment', obj.QuestionName.toLowerCase(), name.toLowerCase() )
                return (obj.QuestionName.toLowerCase() === name.toLowerCase())
            })
        }
        
        
        if (result[0] && result[0].ErrorExplanation) {
            store.errorCommentContent.TempErrorExplanation = result[0].ErrorExplanation;

        } else {
            store.errorCommentContent.TempErrorExplanation = "";
        }
        store.errorCommentContent.CurrentValue = value;
        store.errorCommentContent.RowID = rowId
        store.errorCommentContent.ErrorId = errorId;
        if (result[0]) {

            store.errorCommentContent.WarningFeedback = result[0].ErrorMessage;
            store.errorCommentContent.TypeID = result[0].ErrorTypeID

        }
        store.errorCommentContent.QuestionName = name;

    }
}


export function getErrorCommentValue() {
    ////uhhhh do we even need this method???
    //rowData one needs to be fixed so we can change values from the original json object not a passed down object
    var responseValue = ""
    if (store.allValidationErrorsList[store.currentLandedPage]) {
    
        //responseValue = result[0]['inputValue']
        if (store.errorCommentContent.TempErrorExplanation) {
            responseValue = store.errorCommentContent.TempErrorExplanation
        } else {
            responseValue = "";
        }
 
    }
    return responseValue;
}

export function getCommentIconRenderingInfo(questionName) {
    var commentInfo = {}
    commentInfo.className = ""
    commentInfo.hoverComment = "Add Comment"
    if (checkCommentExists(questionName)) {
        commentInfo.className = " comment-exists ";
        commentInfo.hoverComment = "Edit/Remove Comment"

    }
    return commentInfo;
}

export function getInputRenderingInfo(questionName, inputType, tableName, rowId) {
    var inputRenderingInfo = { inputColor:"", errorExplanation:"", feedbackComment:"", errorId:"", isDisabled:"", textClassName:"", textInputValue:"", validity:true, actualErrorId:"" }
    try {
       
        //changed here for ibs compatibility
        if (tableName && store.allValidationErrorsList[tableName] && store.allValidationErrorsList[tableName].length>0) {
            var result = store.allValidationErrorsList[tableName].filter(obj => {
                if (obj.QuestionName) return obj.QuestionName.toLowerCase() == questionName.toLowerCase() && obj.RowID ===rowId;
            })

        }
        //check error list for questionname match
        else if (store.allValidationErrorsList[store.currentLandedPage] && store.allValidationErrorsList[store.currentLandedPage].length > 0) {
            var result = store.allValidationErrorsList[store.currentLandedPage].filter(obj => {
                return obj.QuestionName.toLowerCase() == questionName.toLowerCase();
            })
        }
       
        if (result && result.length > 0) {
            inputRenderingInfo.errorId = result[0].ErrorTypeID;
            inputRenderingInfo.actualErrorId = result[0].ErrorId ?? null;
            if (result[0].IsAdminOnly && userStore.accountInfo.isAnalyst) {
                inputRenderingInfo.inputColor = " adminWarning"
            }
            else if (inputRenderingInfo.errorId  == 0) {
                inputRenderingInfo.inputColor = " validationError"
            }
            else if (inputRenderingInfo.errorId == 2 || inputRenderingInfo.errorId  == 1) {
                inputRenderingInfo.inputColor = " validationWarning"
            }
            inputRenderingInfo.feedbackComment = result[0].ErrorMessage;
            inputRenderingInfo.errorExplanation = result[0].ErrorExplanation;

            if (inputRenderingInfo.errorExplanation) {
                inputRenderingInfo.inputColor = " dismissed"
            }

        }

        inputRenderingInfo.textInputValue = ""

        if (store.questionMode) { //question mode
            inputRenderingInfo.textClassName = " questionModeInput " 
            inputRenderingInfo.isDisabled = "disabled";
        }
        //Non-analyst on Read Only Survey //needs testing 
        else if (!store.userCanEditReadOnlySurvey) {
            inputRenderingInfo.isDisabled = "disabled";
        }
        //Regular survey input
        else {
            inputRenderingInfo.isDisabled = "";
        }
        return inputRenderingInfo;
    } catch (e) {
        console.log(e)
    }

}

export function checkCommentExists(name) {
    if (store.currentPageResponse) {
        var result = store.currentPageResponse.filter(obj => {
            return obj.QuestionName.toLowerCase() === name.toLowerCase()
        })


        if (result[0] && result[0].Comment) {
            //comment exists
            return true;
        }
    }
    return false;

}

//Set the content for the opened survey preparer modal
export function setPreparerModalContent(id) {
    if (id == undefined) {
        store.surveyPreparerContent['Id'] = "";
        store.surveyPreparerContent['tempEmail'] = "";
        store.surveyPreparerContent['tempFirstName'] = "";
        store.surveyPreparerContent['tempLastName'] = "";
        store.surveyPreparerContent['tempRoles'] = [];

        store.surveyPreparerContent['Email'] = "";
        store.surveyPreparerContent['FirstName'] = "";
        store.surveyPreparerContent['LastName'] = "";
        store.surveyPreparerContent['Roles'] = [];
    }
    else if (store.surveyPreparers) {
        var result = store.surveyPreparers.filter(obj => {
            return obj.Id === id
        })
        store.surveyPreparerContent['Id'] = id;
        //seems overly complicated
        store.surveyPreparerContent['tempEmail'] = result[0]['Email'];
        store.surveyPreparerContent['tempFirstName'] = result[0]['FirstName'];
        store.surveyPreparerContent['tempLastName'] = result[0]['LastName'];
        store.surveyPreparerContent['tempRoles'] = [...result[0]['Roles']];

        store.surveyPreparerContent['Email'] = result[0]['Email'];
        store.surveyPreparerContent['FirstName'] = result[0]['FirstName'];
        store.surveyPreparerContent['LastName'] = result[0]['LastName'];
        store.surveyPreparerContent['Roles'] = [...result[0]['Roles']];
    }
}


export function setTempPreparerModalContent(inputName, value) {
    store.surveyPreparerContent[inputName] = value;
}


export function setActualSurveyPreparerContent() {
    if (store.surveyPreparers) {
        var result = store.surveyPreparers.filter(obj => {
            return obj.Id === store.surveyPreparerContent.Id;
        })
        if (result[0] != null) {
            result[0]['Email'] = store.surveyPreparerContent['tempEmail'];
            result[0]['FirstName'] = store.surveyPreparerContent['tempFirstName'];
            result[0]['LastName'] = store.surveyPreparerContent['tempLastName'];
            result[0]['Roles'] = store.surveyPreparerContent['tempRoles'];
        }
    }
}

export function putCharAt(toInsert, pos, str) {
    if (!toInsert || toInsert?.length > 1 || toInsert?.length > 0) {
        return str;
    }
    if (!pos || !str || toInsert?.length < pos ) {
        return "";
    }

    return str.substring(0, pos) + toInsert + str.substring(pos, toInsert.length - 1);
}
export function dateFormatter(dateStr) {

    if (!dateStr || dateStr.length <= 0) {
        return "";
    }

    if (dateStr.match(/\d\d\d\d\-\d\d\-\d\d/g)) {
        return dateStr.substr(5, 2) + "/" + dateStr.substr(8, 2) + "/" + dateStr.substr(0, 4);
    }

    if (dateStr.length > 10) {
        dateStr = dateStr.substr(0, 10);
    }

    dateStr = dateStr.replace(/\D/g, "");

    if (dateStr.length > 8) {
        dateStr = dateStr.substr(0, 8);
    }

    let returnStr = "";
    if (dateStr.length <= 4) {
        returnStr = dateStr;
    }
    else if (dateStr.length <= 6) {
        returnStr = dateStr.substr(0, dateStr.length - 4) + "/" + dateStr.substr(dateStr.length - 4, 4);
    }
    else {
        returnStr = dateStr.substr(0, dateStr.length - 6) + "/" + dateStr.substr(dateStr.length - 6 , 2) + "/" + dateStr.substr(dateStr.length - 4, 4);
    }

    return returnStr;
}

export function getTodayDate() {
    const today = new Date();
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return monthNames[today.getMonth()] + ' ' + today.getDate() + ', ' + today.getFullYear();
}

export function triggerAnalystCommentModal(questionName) {
    store.showCommentModal = true;
    setCurrentCommentInfo(questionName);
}

export function setLaundromatSelectedRow(id) {
    //find the selected state in list and set to false
    var previouslySelected = store.surveyListDisplay.filter(obj => {
        return obj.selectedState === true;
    })
    if (previouslySelected[0]) previouslySelected[0]['selectedState'] = false;

    var currentSelected = store.surveyListDisplay.filter(obj => {
        return obj.surveyId === id
    })
    if (currentSelected[0]) currentSelected[0]['selectedState'] = true;
}

/**
 * 
 * @param {number} value
 * @returns {number|string} number representation for the currently chosen locale
 */
export function localizeNumber(value) {
    // supposed to take only numbers but javascript ¯\_(ツ)_/¯
    if(value === undefined || value === null || value === "")
        return ""; // TODO or return Number.NaN, check which one is better

    // It's a known non-number value, return as-is
    if(store.local.unknownList.includes(value) || store.local.naList.includes(value) || store.local.noTargetList.includes(value))
        return value;
    
    if (typeof (value) !== "number") {
        value = toNumber(value);
    }

    if(Number.isNaN(value))
        return value;
    
    const decimalDelimiter = numeral.localeData().delimiters.decimal;
    switch(decimalDelimiter) {
        case ",":
            return value.toString().trim().replaceAll(".", ",")
        case ".":
            return value.toString();
    }
}

/**
 * Respects the locale and changes the string into a number object
 * 
 * @param {string} value
 * @returns {number} javascript number object
 */
export function toNumber(value) {
    if(value === undefined || value === null || value === "")
        return Number.NaN;

    if(typeof(value) === 'number') {
        return value;
    }
    
    // supposed to take only strings but javascript ¯\_(ツ)_/¯
    if(typeof(value) !== "string"){
        value = value.toString();
    }

    // Ignore % on the end of the value, if it exists
    if (value.length > 1 && value[value.length - 1] === "%") {
        value = value.slice(0, -1);
    }
    else if (value.length > 0 && value.charAt(0) == "(" && value.charAt(value.length - 1) == ")") {
        value = value.replace("(", "").replace(")", "")
        value = -Math.abs(value)
        return value
    }

    const decimalDelimiter = numeral.localeData().delimiters.decimal;
    const firstIndexOfDecimalDelimiter = value.indexOf(decimalDelimiter);
    if(firstIndexOfDecimalDelimiter >= 0) {
        // Found a decimal delimiter, now look for a second one
        
        const secondIndexOfDecimalDelimiter = value.indexOf(decimalDelimiter, firstIndexOfDecimalDelimiter + 1);
        if (secondIndexOfDecimalDelimiter !== -1) {
            // Found a second decimal delimiter, cut the string here ( auto fix the input )
            value = value.substring(0, secondIndexOfDecimalDelimiter)
        }
    }
    
    switch(decimalDelimiter) {
        case ",":
            const commaDecimalRegex = /([-+])?(\d+(\.\d+)*)(,\d+)?/g;
            if(commaDecimalRegex.test(value) === true) {
                value = value
                    .trim()
                    .replaceAll(".", "") // Remove the thousand delimiters
                    .replaceAll(",", "."); // Modify decimal delimiter to a dot
            } else {
                return Number.NaN;
            }
            break;
        case ".":
            const dotDecimalRegex = /([-+])?(\d+(,\d+)*)(\.\d+)?/g;
            if(dotDecimalRegex.test(value) === true) {
                value = value
                    .trim()
                    .replaceAll(",", ""); // Remove the thousand delimiter
            } else {
                return Number.NaN;
            }
            break;
        default:
            return Number.NaN;
    }
    
    return Number(value);
}

/**
 * Returns the placeholder
 * 
 * @param {string} formatType It will take PlaceholderFormat, if empty, will return currency symbol by itself
 * @returns {string|*} placeholder
 * @public
 */
export function getCurrencyPlaceHolder(formatType) {
    const currencySymbol = numeral.localeData().currency.symbol;
    // localStorage.getItem("lastOpenedSurveyIdCacheDB")
    switch(formatType){
        case PlaceholderFormat.CURRENCY_THOUSAND:
            return `${currencySymbol}000`;
        case PlaceholderFormat.CURRENCY_THOUSANDS:
            return `${currencySymbol}000s`;

        case PlaceholderFormat.CURRENCY_MILS:
            return `${currencySymbol} mils`;
        case PlaceholderFormat.CURRENCY_MILLION:
            return `${currencySymbol} million`;
        case PlaceholderFormat.CURRENCY_MILLIONS:
            return `${currencySymbol} millions`;
        case PlaceholderFormat.CURRENCY_BILLIONS:
            return `${currencySymbol} billions`;

        case PlaceholderFormat.CURRENCY_PLURAL:
            return `${currencySymbol}s`;
        case PlaceholderFormat.CURRENCY_SINGULAR:
            return currencySymbol;
    }

    return currencySymbol;
}

/**
 *
 * @param {string} str
 * @param {string} delimiter
 * @public
 */
export function injectPlaceholder(str, delimiter = '|') {
    if(str === undefined || str === null || str === "")
        return "";

    let injected = ""; // result

    for (let i = 0; i < str.length; i++) {
        if (str[i] === delimiter) {
            // found delimiter
            i++; // go to next char
            // get the placeholderFormat inside the delimiter sandwich
            let placeholderFormat = "";
            while (i < str.length && str[i] !== delimiter) {
                placeholderFormat += str[i];
                i++;
            }
            const placeholder = getCurrencyPlaceHolder(placeholderFormat);
            injected += placeholder;
        } else {
            // non delimiter add it to result
            injected += str[i];

        }
    }

    return injected;
}

export function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}/${date.getFullYear()}`;
    return strTime;
}

export function generateCodeChallenge() {
    var str = crypto.randomBytes(32);
    var verifier = str.toString('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
    var challenge = crypto.createHash('sha256').update(verifier).digest();

    var challengeHashed = challenge.toString('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
    return challengeHashed;
}


export function getOrgName(surveyId) {
    var result = store.pabsSurveysList.filter(survey => survey.SurveyId == surveyId)[0].OrgName;
    return (result)
}

//hackky

export function getPageWarningCountNonAdmin(page) {
    let count = 0;
    const pageL = page.toLowerCase();
    if (store.allValidationErrorsList && store.allValidationErrorsList[pageL]) {
        for (let i = 0; i < store.allValidationErrorsList[pageL].length; i++) {
            if (store.allValidationErrorsList[pageL][i].ErrorTypeID > 0 
                && !store.allValidationErrorsList[pageL][i].ErrorExplanation 
                && store.allValidationErrorsList[pageL][i].IsAdminOnly === false) {
                count = count + 1;
            }
        }
    }
    return count;
}



// TODO this code needs major refactoring
export function addCalculationToResponses(questionName, calculatedVal) {
    //add to responses list so that we can track calculation rules
    if (store.surveyTypeUrl === SurveyTypeURL.PABS || store.surveyTypeUrl === SurveyTypeURL.PABS_UK) {
        var indexOfdata = (store.currentPageResponse).findIndex(function (element) {
            return element.QuestionName === questionName;
        });


        if (questionName && indexOfdata == -1) {
            store.currentPageResponse.push({ "QuestionName": questionName, "InputValue": calculatedVal });
        } else if (questionName && indexOfdata != -1) {
            store.currentPageResponse[indexOfdata].InputValue = calculatedVal;

        }

        
    } else {
        //add to the responses list (so we can show rules for it)
        //var indexOfdata = (ibsStore.allResponses).findIndex(function (element) {
        //    return element === questionName;
        //});


        //if (questionName && indexOfdata == -1) {
        //    //ibsStore.allResponses.push({ "QuestionName": questionName, "InputValue": calculatedVal });
        //} else if (questionName && indexOfdata != -1) {
        //    //ibsStore.allResponses[indexOfdata].InputValue = calculatedVal;

        //}
    }


    
}

export function sortFunction(a, b) {
    if (a.AssetClassCategoryName === b.AssetClassCategoryName) {
        return 0;
    }
    else {
        return (a.AssetClassCategoryName < b.AssetClassCategoryName) ? -1 : 1;
    }
}

export function sortFunctionByID(byId) {
    return function (a, b) {
        if (a[byId] === b[byId]) {
            return 0;
        }
        else {
            return (a[byId] < b[byId]) ? -1 : 1;
        }
    }
}


// Asset Table NA Functions //
/**
 * TODO Try to pass in styleID instead of the name for better implementation
 * @param assetClassCategory
 * @param implementationStyle
 * @returns {boolean}
 */
export function performanceFeesNA(assetClassCategory, assetClassName, implementationStyle) {
    if (assetClassCategory === 'Private Equity') {
        return implementationStyle === 'Internal';
    } else if (assetClassCategory === 'Derivatives/Overlays') {
        if ((assetClassName == "Currency" && implementationStyle == "Ext. Discretionary") ||
            ((assetClassName == "Global TAA" || assetClassName == "Other Overlay"
                || assetClassName == "Long/Short" || assetClassName == "Policy tilt TAA" || assetClassName == "Commodity Futures") && implementationStyle == "External")) {
            return false
        } else {
            return true
        }
    } else {
        // style id != 7 8 9 12 13 16 17 10
        if (implementationStyle === 'External Active' || implementationStyle === 'Ext. Discretionary' || 
            implementationStyle === 'Fund of Funds' || implementationStyle === 'External' || 
            implementationStyle === 'External Not Fund of Fund' || implementationStyle === 'Limited Partnerships' || 
            implementationStyle === 'Operating Subsidiary' || implementationStyle === 'Co-Investments' || 
            implementationStyle === 'Fund (Evergreen)' || implementationStyle === "Fund (LP)" || 
            implementationStyle === 'Fund (LP, Value Add)' || implementationStyle === 'Fund (Evergreen, Core)' || 
            implementationStyle === "Joint Venture" || implementationStyle === "Operating Sub" || 
            implementationStyle === "Co-Investment" || implementationStyle === "Evergreen fund") {   //"Limited-Life Fund" - name change
            return false
        }
    }

    return true
}

// for underlying perf fees column
// for underlying base fees column
export function underlyingFeesNA(assetClassCategory, implementationStyle) {
    // if (assetClassCategory === 'Real Assets' || assetClassCategory === 'Hedge Funds & Funded Global TAA' || 
    //         assetClassCategory === 'Private Equity' || assetClassCategory === 'Private Credit') {
    //     if(implementationStyle !== 'Fund of Funds') return true
    // }
    return implementationStyle !== 'Fund of Funds';
    
}

function isInternalStyle(implementationStyle) {
    return implementationStyle === 'Internal Passive' || implementationStyle === 'Internal Hedge' ||
        implementationStyle === 'Internal Active' || implementationStyle === 'Int. Discretionary' ||
        implementationStyle === 'Internal';
}

export function isExternalStyle(implementationStyle) {
    return implementationStyle.startsWith("Ext")
        || implementationStyle == 'Limited Partnerships'
        || implementationStyle == 'Fund of Funds'
        || implementationStyle == 'Co-Investment';
}

// for manager perf fees column
export function costBaseThousandsNA(implementationStyle) {
    return isInternalStyle(implementationStyle)
}

// fee base column
export function IsInternalMonitoringCostsNA(assetClassCategory, assetClass, implementationStyle) {
    let implementationStyleLC = implementationStyle.toLowerCase();
    let assetClassCategoryLC = assetClassCategory.toLowerCase();
    let assetClassLC = assetClass.toLowerCase();
    /* true if:
        Asset Categories: Bonds, Equity, Multi-Asset
        Impl Style: Internal, Internal Active, Internal Indexed, 
            External Indexed, Co-Investment, Evergreen Fund)
    */
    if (
        assetClassCategoryLC === 'bonds' ||
        assetClassCategoryLC === 'equities' ||
        assetClassLC === 'hedge fund' ||
        assetClassLC === 'risk parity' ||
        assetClassLC === 'funded taa' ||
        implementationStyleLC === `internal` ||
        implementationStyleLC === `internal passive` ||
        implementationStyleLC === `internal active` ||
        implementationStyleLC === `external passive` ||
        implementationStyleLC === `co-investment`
    ) {
        return true;
    } else if (implementationStyleLC === `fund (evergreen)`) {
        /*
            Evergreen should not be true if:
                Infrastructure
                Real Estate
                Natural Resources
                Other real assets
                Private Credit
                Mortgages
        */
        if (
            assetClassLC !== `infrastructure` && 
            assetClassLC !== `real estate` && 
            assetClassLC !== `natural resources` && 
            assetClassLC !== `private credit` && 
            assetClassLC !== `mortgages` && 
            !(assetClassLC === `other` && assetClassCategoryLC === 'real assets')
        ) {

            return true;
        }
        
    }
}

/**
 * TODO Try to pass in styleID instead of the name for better implementation
 * @param categoryClassName
 * @param assetClassName
 * @param implementationStyle
 * @returns {boolean}
 */
export function isFeeBasisNA(categoryClassName, assetClassName, implementationStyle) {
    const na = true;
    const notNa = false;
    if(implementationStyle === undefined)
        return na;
    let implStyle = implementationStyle.toLowerCase()
    //console.log('imp style', 'catname', categoryClassName, 'asset', assetClassName,'imp:', implStyle)
    if (categoryClassName === "Real Assets" || categoryClassName === "Private Debt") {
        if (implStyle === "fund of funds" || implStyle === "fund (evergreen)" || implStyle === "fund (lp)" 
            || implStyle === 'fund (lp, value add)' || implStyle === 'fund (evergreen, core)' || implStyle === "joint venture" || implStyle === 'co-investment') { // name change "limited-life fund") {
            return notNa
        }
    } else if (categoryClassName === "Private Equity") {
        if (implStyle === "fund of funds" || implStyle === "fund (lp)" || implStyle === "fund" 
            || implStyle === 'fund (lp, value add)' || implStyle === 'fund (evergreen, core)' || implStyle==='co-investment') {   // name change "limited-life fund"
            return notNa
        }
    } else if (categoryClassName === "Derivatives/Overlays") {
        let assetClass = assetClassName?.toLowerCase() ?? ""
        if (assetClass === "global taa" || (assetClass === "long/short" && implStyle==="internal")) {
            return na
        } 
        return notNa;
    }
    
    return na;
    //if (implStyle === "limited partnerships" || implStyle === "fund of funds" ||
    //    implStyle === "joint venture" || implStyle === "evergreen fund" || implStyle === "limited-life fund") {
    //    return false
    //}
}

//lets move these to table helper?
export function isAnnualReturnNA(assetClass) {
    let className = assetClass.toLowerCase()
    if (className === "loans" || className === "mutual fund window" || className === "self directed brokerage") {
        return true
    }
    return false
}

export function isPercentPassiveNA(assetClass) {
    let className = assetClass.toLowerCase()
    if (className === "employer stock mandated" || className === "employer stock discretionary" || className === "traditional gic" ||
        className === "stable value / bic / gic funds" || className === "cash / money market" || className === "balanced / target date" || 
        className === "mutual fund window" || className === "participant brokerage account" || className === "loans") {
        return true
    }
    return false
}

export function isMandateStyleNA(assetClass) {
    let className = assetClass.toLowerCase()
    if (className === "employer stock mandated" || className === "employer stock discretionary" || className === "traditional gic" ||
        className === "stable value / bic / gic funds" || className === "cash / money market" || 
        className === "mutual fund window" || className === "participant brokerage account" || className === "loans") {
        return true
    }
    return false
}

export function isManagementFeesNA(assetClass) {
    let className = assetClass.toLowerCase()
    if (className === "traditional gic" || className === "participant brokerage account") return true
    else return false
}

export function stripHtml(html) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}

export function replaceAll(str, find, replace) {
    return str.split(find).join(replace);
}

export function formatDate(dateStr) {
    let date = new Date(dateStr);
    let month = `${date.getMonth() + 1}`.padStart(2, '0');
    let day = `${date.getDate()}`.padStart(2, '0');
    let year = `${date.getFullYear()}`.padStart(4, '0');
    return `${month}/${day}/${year}`;
}

export function FileDownloader(href, download) {
    var a = document.createElement('a');
    a.href = href;
    a.download = download;
    a.click();
}

export function isValidTemplateRow(rowValues) {
    if (rowValues.agrId) {
        if (rowValues.agrId !== "Unknown") {
            return true;
        } else {
            if (rowValues.assetClassId === 999 && rowValues.styleId === 99) {
                return true;
            } else {
                return false;
            }
        }
    } else {
        return false;
    }
}

// IBS only
export function formDateReturnMonth(year) {
    let retMonth = ibsStore?.currentSurvey?.ReturnMonth;
    if ( typeof retMonth !== "number" || !(retMonth > 0 && retMonth <= 12)) {
        retMonth = 12;
    }

    let finalYear = (typeof year === "string") ? parseInt(year): year;
    if (typeof finalYear !== "number") {
        finalYear = ibsStore?.currentSurvey?.DataYear ?? ibsStore.currentSurvey?.currentDataYear;

        // Lets us know if something with year has gone very wrong.
        if (typeof finalYear !== "number") {
            finalYear = -1337;
        }
    }
    let retDay = MonthLength[retMonth];

    if (retMonth === 3 || retMonth === 6) {
        finalYear = finalYear + 1;
    }

    let dateFormat = "dmy";
    if (ibsStore?.currentSurvey?.CountryID === 1) {
        dateFormat = "mdy"
    }

    if (dateFormat === "dmy") {
        return retDay.toString() + "/" + retMonth.toString() + "/" + finalYear.toString();
    }
    if (dateFormat === "mdy") {
        return retMonth.toString() + "/" + retDay.toString() + "/" + finalYear.toString();
    }
    
}

export function sortObjects(aObj, bObj, propertyKey, dataType, direction = "ascending") {
    let aVal = aObj[propertyKey] === null ? getDefaultForType(dataType) : aObj[propertyKey];
    let bVal = bObj[propertyKey] === null ? getDefaultForType(dataType) : bObj[propertyKey];

    if(dataType === 'string') {
        aVal = aVal.toLowerCase();
        bVal = bVal.toLowerCase();
        return direction === 'ascending'
            ? aVal.localeCompare(bVal, undefined, { sensitivity: 'base' })
            : bVal.localeCompare(aVal, undefined, { sensitivity: 'base' });
        
    } else if(dataType === 'date') {
        aVal = new Date(aVal).getTime();
        bVal = new Date(bVal).getTime();
        return direction === 'ascending'
            ? aVal > bVal ? 1 : aVal < bVal ? -1 : 0
            : aVal > bVal ? -1 : aVal < bVal ? 1 : 0;
        
    } else if(dataType === 'number'){
        if (isNaN(aVal)) aVal = -Infinity;
        if (isNaN(bVal)) bVal = -Infinity;
        return direction === 'ascending'
            ? aVal > bVal ? 1 : aVal < bVal ? -1 : 0
            : aVal > bVal ? -1 : aVal < bVal ? 1 : 0;
        
    } else if(dataType === 'agrId') {
        const aAssetStyle = hasAssetStyle(aVal) ? aVal.slice(0, 2) : "";
        const aAssetClass = hasAssetStyle(aVal) ? aVal.slice(2) : aVal;
        const bAssetStyle = hasAssetStyle(bVal) ? bVal.slice(0, 2) : "";
        const bAssetClass = hasAssetStyle(bVal) ? bVal.slice(2) : bVal;

        let comparisonResult = direction === 'ascending'
            ? aAssetClass.localeCompare(bAssetClass, undefined, { sensitivity: 'base' })
            : bAssetClass.localeCompare(aAssetClass, undefined, { sensitivity: 'base' });

        if (comparisonResult === 0) {
            // asset class is the same, now compare the style
            comparisonResult = direction === 'ascending'
                ? aAssetStyle.localeCompare(bAssetStyle, undefined, { sensitivity: 'base' })
                : bAssetStyle.localeCompare(aAssetStyle, undefined, { sensitivity: 'base' });
        }

        return comparisonResult;
        
    } else if (dataType === "bool") {
        return direction === 'ascending'
            ? (aVal === bVal) ? 0 : aVal ? 1 : -1
            : (aVal === bVal) ? 0 : aVal ? -1 : 1;
        
    } else {
        return sortUnknownObjects(aVal, bVal, direction);
    }
}

function sortUnknownObjects(aObj, bObj, direction) {
    if (aObj == null)
        aObj = "";
    if (bObj == null)
        bObj = "";

    if (typeof aObj == "string")
        aObj = aObj.toLowerCase();

    if (typeof bObj == "string")
        bObj = bObj.toLowerCase();

    if (aObj > bObj) {
        return direction === 'ascending' ? 1 : -1;
    } else if (aObj < bObj) {
        return direction === 'ascending' ? -1 : 1;
    } else {
        return 0;
    }
}

function hasAssetStyle(agrId) {
    // if the first character is an uppercase, it means that it is the Asset Class
    return agrId.charAt(0).toUpperCase() !== agrId.charAt(0);
}

function getDefaultForType(dataType) {
    switch(dataType) {
        case 'string':
        case 'agrId':
            return "";
        case 'number':
            return -Infinity;
        case 'date':
            return new Date(0).getTime();
        default:
            return null;
    }
}


export function isPabsURL(path) {
    const pabsPaths = [SurveyTypeURL.PABS, SurveyTypeURL.PABS_UK, SurveyTypeURL.PABS_LG];
    return pabsPaths.some(path => window.location.href.includes(path));
};

export function safeJsonParse(str, fallback = {}) {
    try {
        return str && str.trim() ? JSON.parse(str) : fallback;
    } catch (e) {
        console.error("JSON parse error:", e);
        return fallback;
    }
}
